import { atomsmartmetering } from "./atomsmartmetering/flavour";
import { precisionsmartmetering } from "./precisionsmartmetering/flavour";
import { thermocloud } from "./thermocloud/flavour";
import { useEffect } from "react";
import {
  applyThemeColors as applyThemeColorsUtil,
  getThemeColors,
  isDarkMode,
} from "../util/theme";

function getSubdomain(): string | null {
  const host = window.location.hostname;
  const parts = host.split(".");

  if (parts.length >= 3) {
    return parts[0];
  }

  return null;
}

const useWhiteLabel = () => {
  const subdomain = getSubdomain();

  // Default to Demo
  let images = atomsmartmetering.images;
  let colors = atomsmartmetering.colors;
  let translations = atomsmartmetering.translations;
  let links = atomsmartmetering.links;
  let platform = atomsmartmetering.platform;
  let availableReports = atomsmartmetering.availableReports;

  switch (subdomain) {
    case "precision":
      images = precisionsmartmetering.images;
      colors = precisionsmartmetering.colors;
      translations = precisionsmartmetering.translations;
      links = precisionsmartmetering.links;
      platform = precisionsmartmetering.platform;
      availableReports = precisionsmartmetering.availableReports;
      break;
    case "thermocloud":
      images = thermocloud.images;
      colors = thermocloud.colors;
      translations = thermocloud.translations;
      links = thermocloud.links;
      platform = thermocloud.platform;
      availableReports = thermocloud.availableReports;
      break;
    default:
      // images = thermocloud.images;
      // colors = thermocloud.colors;
      // translations = thermocloud.translations;
      // links = thermocloud.links;
      // platform = thermocloud.platform;
      // availableReports = thermocloud.availableReports;
      images = atomsmartmetering.images;
      colors = atomsmartmetering.colors;
      translations = atomsmartmetering.translations;
      links = atomsmartmetering.links;
      platform = atomsmartmetering.platform;
      availableReports = atomsmartmetering.availableReports;
      // images = precisionsmartmetering.images;
      // colors = precisionsmartmetering.colors;
      // translations = precisionsmartmetering.translations;
      // links = precisionsmartmetering.links;
      // platform = precisionsmartmetering.platform;
      break;
  }

  // Function to apply theme colors
  const applyThemeColors = (isDark: boolean) => {
    const themeColors = getThemeColors(colors, isDark);
    applyThemeColorsUtil(themeColors);
  };

  // Apply theme colors when the hook is used
  useEffect(() => {
    const isDark = isDarkMode();
    applyThemeColors(isDark);
  }, []);

  return {
    images,
    colors,
    translations,
    links,
    platform,
    availableReports,
    applyThemeColors,
  };
};

export default useWhiteLabel;
